import posthog from 'posthog-js'

const isBrowser = typeof window !== 'undefined'
const isProduction = process.env.APP_ENV === 'production'
// Enabled on staging too so we can verify events/recordings before they ship to
// prod. Requires NEXT_PUBLIC_POSTHOG_KEY to be set in the staging environment.
const isStaging = process.env.APP_ENV === 'staging'

// Force-enable on non-prod by visiting any URL with `?ph_record=1`. Reload
// without the param (or close the tab) to stop. Evaluated once at init.
const isForceRecord = () => {
  if (!isBrowser) return false
  return new URLSearchParams(window.location.search).get('ph_record') === '1'
}

const shouldEnable =
  isBrowser &&
  !!process.env.NEXT_PUBLIC_POSTHOG_KEY &&
  (isProduction || isStaging || isForceRecord())

if (shouldEnable) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host:
      process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    // Recording is started manually from CurrentUserProvider once we know the
    // user is an authenticated coach on /dashboard/*.
    disable_session_recording: true,
    session_recording: {
      sampleRate: isProduction ? '0.1' : '1.0',
      minimumDurationMilliseconds: isProduction ? 5000 : 0,
    },
  })
}

export const isPostHogEnabled = () => shouldEnable

export default posthog
